module.exports = __webpack_public_path__ + "static/media/create-post.204812ac.svg";